import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { getCoachesList } from '../actions/coachActions';
import CoachesList from '../components/CoachesList';

const mapDispatchToProps = dispatch => {
  return {
    getCoachesList: (seasonId) => {
      dispatch(getCoachesList(seasonId));
    }
  };
};

const mapStateToProps = state => ({
  coachesList: state.lists.coachesList,
  fetchingCoachesList: state.lists.fetchingCoachesList,
  userSeason: state.user.userSeason
});

const CoachesListContainer = withRouter(connect(mapStateToProps, mapDispatchToProps)(CoachesList));
export default CoachesListContainer;



// WEBPACK FOOTER //
// ./src/containers/CoachesListContainer.js